export enum CustomDataOperators {
  Add = 1,
  Subtract,
  Multiply,
  Divide,
}
